import { isEmpty, get } from 'utils/lodash';
/**
 * Проверяет, существует ли хотя бы одно значение в массиве, отличное от null/undefined
 *
 * @param {array} values массив проверяемых значений
 */
export const checkValuesExist = (values) => values.some((value) => (typeof value === 'object' ? !isEmpty(value) : Boolean(value)));

const isValueEmpty = (value) => value === undefined || value === null || value === '';

export const validateData = (values = {}, required = []) => {
  const hasError = required.some((field) => {
    const fieldType = typeof field;
    if (fieldType === 'string' || fieldType === 'number') {
      return isValueEmpty(get(values, field));
    } else if (field && fieldType === 'object') {
      return Object.keys(field).some((key) => field[key] && isValueEmpty(get(values, key)));
    }
    return false;
  });
  return !hasError;
};

export const makeFormattedBoolean = (value, defaultValue = '—') => {
  if (isValueEmpty(value)) {
    return defaultValue;
  }
  return String(value) === 'true' ? 'Да' : 'Нет';
};

export const isFilledArray = (item) => {
  if (!Array.isArray(item)) return false;
  return item.length > 0;
};
